import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const BodyText = ({ title, text, children }) => {
  return (
    <Box mt={3} mb={5}>
      {title && (
        <Typography variant="body1" color="light-gray-text.main" mb={1}>
          {title}
        </Typography>
      )}
      {text && (
        <Typography variant="body1" color="dark-text.main">
          {text}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default BodyText;
